import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    LastVisitCounts,
    forumHeaderUpdate,
    forumUpdateComplaintsStatistics,
} from "@/mk2/apps/forum/actions";
import {
    FORUM_CATEGORIES_FETCH_TRIGGER,
    ForumCategoriesFetchNormalizedResponse,
    ForumCategoriesFetchTriggerAction,
    forumCategoriesFetch,
} from "@/mk2/apps/forum/containers/ForumCategories/ForumCategories.actions";
import { ComplaintsStatisticsPerPost } from "@/mk2/apps/forum/schemas";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { forum_api_get_categories_url } from "@/mk/urls/functions";

import { CategoryEntity, CategorySchema, TopicEntity, TopicSchema } from "../../schemas";

const logger = getLogger("forum/ForumCategories.sagas");

interface ApiResponse {
    body: {
        categories: CategoryEntity[];
        activeDaysWithTopic: TopicEntity;
        contestsTopic: TopicEntity;
        testingsTopic: TopicEntity;
        counsellingCategory: CategoryEntity;
        followingTopics: TopicEntity[];
        lastVisitCounts: LastVisitCounts;
        complaintsStatistics: ComplaintsStatisticsPerPost;
        numTopicsInCategory: { [categoryId: number]: number };
    };
}

export function* fetchCategories({ xhr }: ForumCategoriesFetchTriggerAction & XHRAction) {
    yield put(forumCategoriesFetch.request());

    try {
        const response: ApiResponse = yield call(() => xhr.get(forum_api_get_categories_url()));

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));

        const normalizedResponse: ForumCategoriesFetchNormalizedResponse = normalize(
            response.body,
            {
                categories: [CategorySchema],
                activeDaysWithTopic: TopicSchema,
                contestsTopic: TopicSchema,
                testingsTopic: TopicSchema,
                counsellingCategory: CategorySchema,
                followingTopics: [TopicSchema],
            },
        );
        yield put(forumCategoriesFetch.success(normalizedResponse));

        yield put(forumHeaderUpdate(response.body.lastVisitCounts));
    } catch (error) {
        logger.error(error);
        yield put(forumCategoriesFetch.failure(normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(FORUM_CATEGORIES_FETCH_TRIGGER, fetchCategories)]);
}
